import { render, staticRenderFns } from "./ModalAddPerson.vue?vue&type=template&id=cda65b0a&scoped=true&"
import script from "./ModalAddPerson.vue?vue&type=script&lang=js&"
export * from "./ModalAddPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda65b0a",
  null
  
)

export default component.exports